<template lang="pug">
  div.msn.with-containers
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :showTotal="true"
      :showExport="true"
      :tableId="tableId"
      :endpointExport="getEndpointExport()"
    )
    e-table(
      :items="items"
      @deleteItem="deleteItem"
      @editItem="editItem"
      :showCheckbox="false"
      :actionColumnWidth="100"
    )
    router-view
</template>

<script>
import { msn, export_document } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'
import RouteMixin from '@/mixins/route-mixin'
import textMixin from '@/mixins/text-mixin'
import hasMixin from '@/mixins/has-mixin'
import MnoButtons from './components/mno-buttons'
import { statuses } from '@/app/geo/config/statuses.js'

const methods = {
  needed_containers_and_bunkers: 'withBunkers',
  with_containers: 'withContainers',
  'with_containers,separate_collection': 'withContainers,separate_collection',
  'individual_collection,with_containers':
    'withContainers,individualCollection',
  planned_buy: 'withPlanned',
  without_containers: 'withoutContainers',
  special_sites_kgo: 'specialSitesKgo',
  waste_collection: 'wasteCollections',
  mkd_waste_chamber: 'mkdWasteChamber',
  individual_collection: 'individualCollection',
}
export default {
  components: { MnoButtons },
  mixins: [tableMixin, RouteMixin, textMixin, hasMixin],
  computed: {
    tableId() {
      return this.$route.name
    },
  },
  watch: {
    $route: 'onRoute',
  },
  methods: {
    getEndpoint(route) {
      if (route.meta.status) {
        const status = statuses.find(
          (status) => status.slug === route.meta.status
        )
        const statusId = status ? status.id : null
        return msn.containers(route, route.meta.name, statusId)
      }
      return msn.containers(route, route.meta.name)
    },
    getDeleteUrl(id) {
      return msn.containerDelete(id)
    },
    getEndpointExport() {
      return export_document.msn[methods[this.$route.meta.name]](this.$route)
    },
  },
}
</script>
